import gql from 'graphql-tag';

export default gql`
 mutation upload($file: Upload, $path: String) {
  upload(file: $file, path: $path) {
    path
  }
 }
`;